import { IUser } from '../../Auth/models/user.model';

/**
 * Regra de visibilidade do onboarding (ver doc backend, seção 2):
 * exibir SOMENTE enquanto o aluno ainda não participou de nenhum onboarding.
 *
 * `onboardingAttended` vira `true` assim que o aluno entra na live pela
 * plataforma (endpoint de join). Usamos comparação estrita com `false` para,
 * na ausência do campo (undefined), NÃO exibir — rollout conservador.
 */
export function shouldShowOnboarding(user?: IUser | null): boolean {
  return user?.onboardingAttended === false;
}
